var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"400"},on:{"input":function($event){return _vm.$router.push('/')}},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{staticClass:"pa-5"},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.dialogText)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }